/* 0.44.51 - Icons added in Settings > Icons, loaded once per page load
 * from /api/icons and shared by every BuiltinIcon. An icon is named
 * "custom.<key>" wherever icons are chosen.
 *
 * The SVG markup was cleaned by the server when the icon was added (only
 * drawing elements and attributes are kept), so it is drawn inline. */
import { useEffect, useState } from 'react';

let icons = null;            // { 'custom.key': {label, view_box, attrs, inner} }
let list = [];               // [{name, key, label, ...}] in label order
let loading = null;
const listeners = new Set();

function publish(data) {
  list = Array.isArray(data) ? data : [];
  icons = Object.fromEntries(list.map(i => [i.name || `custom.${i.key}`, i]));
  listeners.forEach(fn => fn());
}

export function loadCustomIcons(force = false) {
  if (loading && !force) return loading;
  loading = fetch('/api/icons', { credentials: 'include', cache: 'no-store' })
    .then(r => (r.ok ? r.json() : []))
    .catch(() => [])
    .then(data => { publish(data); return list; });
  return loading;
}

export const refreshCustomIcons = () => loadCustomIcons(true);

export function getCustomIcon(name) {
  return icons ? icons[name] || null : null;
}

/* The list, re-rendering when it loads or changes. */
export function useCustomIcons() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const fn = () => setTick(t => t + 1);
    listeners.add(fn);
    if (!icons) loadCustomIcons();
    return () => listeners.delete(fn);
  }, []);
  return list;
}
